import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const reveal = (img_elm, head_elm, text_elm) => {

    let tl=gsap.timeline();
    tl.to(img_elm, {
        duration: 1.3,
        ease: "power4.out",
        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
    })
    .to(head_elm,{
        duration: 1,
        y:0,
        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        ease: "power4.out",
    },"-=1")
    .to(text_elm, {
        duration: 0.9,
        opacity: 1,
        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        y:0,
        ease: "power4.out"
    },"-=1");
    return tl;
}






const host = () => {


    let head_elm = document.querySelectorAll(".about-host__heading-wrapper");
    let text_elm = document.querySelectorAll(".about-hosts__text-wrapper");
    let img_elm = document.querySelectorAll(".about-host__image-wrapper");

    ScrollTrigger.create({
        trigger: img_elm,
        toggleActions:"play none none reverse",
        animation: reveal(img_elm, head_elm, text_elm)
      });

      ScrollTrigger.create({
        trigger: ".why-host__image-wrapper",
        toggleActions:"play none none reverse",
        animation: reveal(".why-host__image-wrapper", ".why-host__heading-wrapper", ".why-hosts__text-wrapper")
      });

      ScrollTrigger.create({
        trigger: ".unique-section__image-wrapper",
        toggleActions:"play none none reverse",
        animation: reveal(".unique-section__image-wrapper", ".unique-host__heading", ".unique-section__text")
      });

    //   ScrollTrigger.create({
    //     trigger: ".why-host__image-wrapper",
    //     start: "top top",
    //     onEnter: reveal( ".why-host__image-wrapper")
    //   });

    //   ScrollTrigger.create({
    //     trigger: ".unique-section__image-wrapper",
    //     start: "top top",
    //     onEnter: reveal( ".unique-section__image-wrapper")
    //   });

}

export default host;